const game = {
    play :  (test) => {
        return `Hello ${test}`;
    }
}

export default game;